<template>
<div v-if="true">
	<v-dialog v-model="dialogue.confirmRequested" persistent width="300px">
		<v-card>
			<v-card-title class="headline">
				{{dialogue.title}}
			</v-card-title>
			<v-card-text>
				{{dialogue.text}}
			</v-card-text>
			<v-card-actions>
				<v-btn flat color="secondary" @click="yes">
				<v-icon v-if="dialogue.iconYes">{{dialogue.iconYes}}</v-icon>
				{{dialogue.textYes}}
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn flat @click="no">
					<v-icon v-if="dialogue.iconNo">{{dialogue.iconNo}}</v-icon>
					{{dialogue.textNo}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmLogin",

	computed: {
		...Vuex.mapState({ dialogue: (state) => state.dialogue.confirm })
	},

	methods: {
		...Vuex.mapActions({ yes: 'dialogue/confirm/yes', no: 'dialogue/confirm/no' })
	}
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmYesNo.vue